import axios from "axios";

const API_URL = "https://api.mebook.ai/api/";
// const API_URL = 'http://localhost:5001/api/';
export const getTemplates = async (lang, clientId, templateId) => {
    const params = {
        language: lang,
        isRandom: 1,
        limit: 50,
        clientId
    };
    if (templateId) {
        params.templateId = templateId;
    }
    const response = await axios.get(`${ API_URL }site/templates`, { params });
    return response.data.data;
};


export const getConfig = async (lang, clientId) => {
    const response = await axios.get(`${ API_URL }/frame/config-v2?lang=${ lang }&clientId=${ clientId }`);
    return response.data.data;
};
